// extracted by mini-css-extract-plugin
module.exports = {"PhotoSlide":"PhotoSlide_PhotoSlide__1lJFf"};